import { render, staticRenderFns } from "./ActionField.vue?vue&type=template&id=13c4830f&scoped=true"
import script from "./ActionField.vue?vue&type=script&lang=js"
export * from "./ActionField.vue?vue&type=script&lang=js"
import style0 from "./ActionField.vue?vue&type=style&index=0&id=13c4830f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4830f",
  null
  
)

export default component.exports